import React, {type ReactElement} from "react";

import Icon from "../../icon/Icon";
import Image, {ImageObject} from "../../image/Image";

import QuoteIcon from "/src/svg/quote-icon.svg";
import {MaybeType} from "/src/types";

import {css} from "/src/utils/utils";

import * as styles from "./quote.module.scss";

export interface QuoteProps {
  quote: string;
  name: string;
  role: string;
  image?: MaybeType<ImageObject>;
  largeImage?: MaybeType<ImageObject>;
  darkMode?: boolean;
  isFormLayout?: boolean;
  transparent?: boolean;
  contentClasses?: string;
}

const Quote = (props: QuoteProps): ReactElement => {
  const {
    name,
    role,
    quote,
    image,
    largeImage,
    darkMode = false,
    isFormLayout = false,
    transparent = false,
    contentClasses,
  } = props;

  return (
    <figure
      className={css(
        styles.quote,
        transparent
          ? styles.quoteTransparent
          : darkMode
          ? styles.quoteDark
          : "",
        isFormLayout ? styles.quoteOnForm : "",
        largeImage ? styles.quoteWithImage : "",
        contentClasses!
      )}
    >
      <div className={styles.quote__contentWrapper}>
        <Icon svg={QuoteIcon} classes={styles.quote__icon} />

        <blockquote className={css("p", styles.quote__blockquote)}>
          <span>{quote}</span>
        </blockquote>

        <figcaption className={styles.quote__caption}>
          {image && <Image image={image} classes={styles.quote__avatar} />}

          <div>
            <p className={css("cta-large", styles.quote__author__name)}>
              {name}
            </p>

            <p className={css("caption", styles.quote__author__role)}>{role}</p>
          </div>
        </figcaption>
      </div>

      {largeImage && (
        <div className={styles.quote__largeImageWrapper}>
          <Image image={largeImage} classes={styles.quote__largeImage} />
        </div>
      )}
    </figure>
  );
};

export default Quote;
